import loadPagesLogic from "./loadPagesLogic";
import loadPagesFailLogic from "./loadPagesFailLogic";
import createPageLogic from "./createPageLogic";
import createPageSuccessLogic from "./createPageSuccessLogic";
import createPageFailLogic from "./createPageFailLogic";
import selectPagesLogic from "./selectPageLogic";
import selectPagesFailLogic from "./selectPageFailLogic";
import editPageLogic from "./editPageLogic";
import editPageSuccessLogic from "./editPageSuccessLogic";
import editPageFailureLogic from "./editPageFailureLogic";
import deletePageLogic from "./deletePageLogic";
import deletePageSuccessLogic from "./deletePageSuccessLogic";
import deletePageFailureLogic from "./deletePageFailureLogic";

export default [
	...loadPagesLogic,
	...loadPagesFailLogic,
	...createPageLogic,
	...createPageSuccessLogic,
	...createPageFailLogic,
	...selectPagesLogic,
	...selectPagesFailLogic,
	...editPageLogic,
	...editPageSuccessLogic,
	...editPageFailureLogic,
	...deletePageLogic,
	...deletePageSuccessLogic,
	...deletePageFailureLogic,
];
